import { Divider, Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import errorPage from '../../assets/images/errorPage.jpg';
import { useLoaderContext } from '../../contexts/LoaderContext';
import { useQueryController } from '../../hooks/useQueryController';
import { VdsButton } from '../../vds';
import { StyledTitle } from '../../components/StyledTitle';
import { StyledDescription } from '../../components/StyledDescription';

export const InvalidUserPage: React.FC = () => {

    const queryParams = useQueryController();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
    }, []);

    return (
        <Grid height="100%" container>
            {matches && (
                <Grid
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sm={5}
                    sx={{ backgroundColor: '#E5EAF0' }}
                    item
                >
                    <img src={errorPage} width="300" alt='genericPage' />
                </Grid>
            )}
            <Grid
                sm={matches ? 7 : 12}
                item
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={2}
                    overflow="auto"
                    height="100%"
                >
                    <StyledTitle>
                        ATTENZIONE!
                    </StyledTitle>
                    <Divider orientation="horizontal" />
                    <StyledDescription>
                        L&#39;utente TSID con cui sei collegato, non coincide con l&#39;indirizzo e-mail su cui hai ricevuto la promozione esclusiva.
                        <br />
                        <br />
                        Effettua il logout e accedi con l&#39;account corretto.
                    </StyledDescription>
                    <Box
                        sx={{
                            padding: '0 32px',
                        }}
                    >
                        <VdsButton
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                window.location.href = window.location.origin + "?token=" + queryParams.token + "&clear=true";
                            }}
                            sx={{
                                width: '100px'
                            }}
                        >
                            Logout
                        </VdsButton>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};
